import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Phone, Calendar } from "lucide-react";
import { ASSETS, CONTACT } from "@/lib/assets";

const NAV = [
  { label: "Tjenester", href: "#tjenester" },
  { label: "Galleri", href: "#galleri" },
  { label: "Omtaler", href: "#omtaler" },
  { label: "FAQ", href: "#faq" },
  { label: "Kontakt", href: "#kontakt" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "py-3" : "py-5"
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div
          className={`flex items-center justify-between rounded-full transition-all duration-500 ${
            scrolled
              ? "glass px-3 pl-4 sm:pl-5 py-2"
              : "px-2 sm:px-3 py-2"
          }`}
        >
          <a href="#top" className="flex items-center gap-3 group" data-testid="nav-logo">
            <img
              src={ASSETS.logoIcon}
              alt="Høie Service logo"
              className="h-9 w-9 sm:h-10 sm:w-10 transition-transform duration-700 group-hover:rotate-180"
            />
            <span className="hidden sm:flex flex-col leading-tight">
              <span className="text-[15px] font-bold tracking-wide text-white">
                HØIE <span className="text-coral">SERVICE</span>
              </span>
              <span className="mono text-[10px] uppercase tracking-[0.22em] text-white/50">
                Energi · Sveio
              </span>
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                data-testid={`nav-link-${n.label.toLowerCase()}`}
                className="px-4 py-2 text-sm text-white/75 hover:text-white transition-colors relative group"
              >
                {n.label}
                <span className="absolute left-4 right-4 -bottom-0.5 h-px bg-cyan scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href={`tel:${CONTACT.phoneRaw}`}
              className="hidden sm:inline-flex btn-ghost btn !py-2.5 !px-4 text-sm"
              data-testid="nav-phone"
            >
              <Phone className="w-4 h-4" />
              {CONTACT.phone}
            </a>
            <a href="#kontakt" className="btn btn-primary !py-2.5 !px-4 text-sm" data-testid="nav-cta">
              Gratis befaring
            </a>
            <Link to="/bestill" className="hidden sm:inline-flex btn btn-coral !py-2.5 !px-4 text-sm" data-testid="nav-book">
              <Calendar className="w-4 h-4" />
              Bestill service
            </Link>
            <button
              className="md:hidden p-2 text-white"
              onClick={() => setOpen((v) => !v)}
              aria-label="Meny"
              data-testid="nav-mobile-toggle"
            >
              {open ? <X /> : <Menu />}
            </button>
          </div>
        </div>

        {open && (
          <div className="md:hidden mt-2 glass rounded-2xl p-3 flex flex-col" data-testid="nav-mobile-menu">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="px-4 py-3 text-white/85 hover:text-cyan border-b last:border-0 hairline"
              >
                {n.label}
              </a>
            ))}
            <Link
              to="/bestill"
              onClick={() => setOpen(false)}
              className="px-4 py-3 mt-1 text-coral font-semibold flex items-center gap-2"
              data-testid="nav-mobile-book"
            >
              <Calendar className="w-4 h-4" /> Bestill varmepumpe service
            </Link>
          </div>
        )}
      </div>
    </header>
  );
}
